export default "__VITE_ASSET__CJ44SHid__"